import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { StoreState, useAppDispatch } from 'store';
import { VerifyEmailPayload } from 'features/admin-email-verification/api/types';
import { emailVerificationActions } from 'features/admin-email-verification/redux/email-verification.actions';

export default function useEmailVerification() {
  const dispatch = useAppDispatch();
  const emailVerificationState = useSelector(
    (state: StoreState) => state.emailVerificationReducer
  );

  const verifyEmail = useCallback(
    (data: VerifyEmailPayload) => {
      dispatch(emailVerificationActions.verifyEmailRequest(data));
    },
    [dispatch]
  );

  const sendEmailVerificationToken = useCallback(() => {
    dispatch(emailVerificationActions.sendEmailVerificationTokenRequest());
  }, [dispatch]);

  const resetState = useCallback(() => {
    dispatch(emailVerificationActions.resetState());
  }, [dispatch]);

  return {
    emailVerificationState,
    verifyEmail,
    sendEmailVerificationToken,
    resetState,
  };
}
